// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const gouging_fire: PokeData = {
  "id": 1020,
  "name": "gouging-fire",
  "height": 35,
  "weight": 5900,
  "base_experience": 295,
  "types": [
    PokeType.FIRE,
    PokeType.DRAGON
  ],
  "api_moves": [
    "stomp",
    "leer",
    "bite",
    "fire-blast",
    "outrage",
    "morning-sun",
    "sunny-day",
    "crush-claw",
    "howl",
    "dragon-claw",
    "flare-blitz",
    "dragon-rush",
    "fire-fang",
    "lava-plume",
    "incinerate",
    "raging-fury",
    "burning-bulwark"
  ],
  "moves": [
    "leer",
    "bite",
    "outrage",
    "morning-sun",
    "sunny-day",
    "dragon-claw",
    "flare-blitz",
    "dragon-rush",
    "fire-fang",
    "draco-meteor",
    "flamethrower",
    "dragon-dance",
    "inner-spirit"
  ],
  "evolution_chain": {
    "id": 544,
    "item": null,
    "species": [
      {
        "name": "gouging-fire",
        "order": 1022,
        "types": [
          PokeType.FIRE,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 136,
    "speed": 117,
    "ability_power": 147
  },
  "stat_changes": [],
  "catch_rate": 10,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
